<div class="row">
  <div class="col-xs-12">
    <div class="small footer-default">
      {{ 'PARTECIPANT_LTI.RESULTS.SELECT_YEAR' | translate }}
    </div>
    <select
      id="selectYearEl"
      class="form-control"
      name="sel-activity"
      [(ngModel)]="currentYear"
    >
      <option *ngFor="let year of getYears()" [ngValue]="year">
        {{ year }}
      </option>
    </select>

    <div id="widgetsContainer">
      <div id="bonusAccrued" class="widget collapsed">
        <div class="widgetHeader">
          <div class="widgetHeaderInfo">
            <div class="small widgetTitle">
              {{
                'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.TITLE' | translate
              }}
            </div>
            <div class="veryBig widgetAmount">
              {{ formatNumber(getAmount('accrued')) }}
            </div>
          </div>
        </div>

        <div class="widgetBody">
          <div class="widgetProgressAccrued">
            <progressbar
              type="warning"
              [value]="getAmount('accrued')"
              [max]="getAmount('accrued_max')"
            ></progressbar>
          </div>
          <div class="display-flex-center" id="accruedCollapsedDetails">
            <div class="accruedCollapsedDetailsItem">
              <div class="medium accruedCollapsedDetailsAmount">
                {{ formatNumber(getAmount('accrued_payable')) }}
              </div>
              <div class="small">
                {{
                  'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.PAYABLE'
                    | translate
                }}
              </div>
            </div>
            <div class="accruedCollapsedDetailsItem">
              <div class="medium accruedCollapsedDetailsAmount">
                {{ formatNumber(getAmount('accrued_deferred')) }}
              </div>
              <div class="small">
                {{
                  'PARTECIPANT_LTI.RESULTS.BONUS_ACCRUED_WIDGET.DEFERRED'
                    | translate
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
